if (!customElements.get('tier-size-picker')) {
  customElements.define(
    'tier-size-picker',
    class TierSizePicker extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialised === 'true') {
          this.form?.addEventListener('submit', this.handleSubmit, true);
          return;
        }
        this.dataset.initialised = 'true';
        this.form = this.closest('form');
        this.status = this.querySelector('[data-tier-size-status]');
        this.addEventListener('click', this.handleClick);
        this.form?.addEventListener('submit', this.handleSubmit, true);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.handleSubmit, true);
      }

      handleClick = (event) => {
        const button = event.target.closest('[data-tier-select]');
        if (!button || !this.contains(button) || button.disabled) return;
        const tier = button.dataset.tierSelect;
        if (!tier || button.getAttribute('aria-pressed') === 'true') return;

        this.dataset.activeTier = tier;
        this.querySelectorAll('[data-tier-select]').forEach((control) => {
          control.setAttribute('aria-pressed', control === button ? 'true' : 'false');
        });
        this.querySelectorAll('[data-size-group]').forEach((group) => {
          group.hidden = group.dataset.sizeGroup !== tier;
        });
        this.querySelectorAll('[data-tiered-size-value]').forEach((input) => {
          input.checked = false;
        });

        const activeGroup = this.querySelector(`[data-size-group="${CSS.escape(tier)}"]`);
        const firstAvailableSize = activeGroup?.querySelector(
          '[data-tiered-size-value]:not(.product-option__input--unavailable):not(:disabled)'
        );
        const submit = this.form?.querySelector('[name="add"]');
        if (firstAvailableSize) {
          delete this.dataset.sizePending;
          firstAvailableSize.checked = true;
          if (submit) {
            submit.disabled = true;
            submit.setAttribute('aria-disabled', 'true');
          }
          if (this.status) {
            this.status.removeAttribute('role');
            this.status.textContent = `Selected ${firstAvailableSize.value}. You can choose another size below.`;
          }
          firstAvailableSize.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        this.dataset.sizePending = 'true';
        if (submit) {
          submit.disabled = false;
          submit.removeAttribute('aria-disabled');
        }
        if (this.status) {
          this.status.textContent = 'No available size was found for this tier. Choose another tier.';
          this.status.setAttribute('role', 'alert');
        }
      };

      handleSubmit = (event) => {
        const selectedSize = this.querySelector('[data-tiered-size-value]:checked');
        if (selectedSize && this.dataset.sizePending !== 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.status) {
          this.status.textContent = 'Choose a size before adding this cake.';
          this.status.setAttribute('role', 'alert');
        }
        const activeGroup = this.querySelector(`[data-size-group="${CSS.escape(this.dataset.activeTier || '')}"]`);
        activeGroup?.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
        requestAnimationFrame(() => activeGroup?.focus());
      };
    }
  );
}
